<template>
  <div class="inscription-and-bank-details mb-4">
    <div class="section-title-container d-flex align-items-center mb-3 gap-1">
      <h5 class="section-title m-0 fw-bold">Detalles del curso:</h5>
      <h4 class="fw-bold m-0 fs-6">{{ courseName || 'Curso no seleccionado' }}</h4>
    </div>
    
    <div class="course-dark-card p-4 text-white">
      <!-- Fila 1: Detalles de la Inversión -->
      <div class="row">

         <div class="col-4">
          <span class="card-label-mini">Monto Pendiente</span>
          <div class="fw-bold fs-5 mt-1">${{ parseFloat(totalPending || 0).toFixed(2) }} USD</div>
        </div>

        <div class="col-4">
          <span class="card-label-mini">Monto Pagado</span>
          <div class="fw-bold fs-5 mt-1">${{ parseFloat(totalPaid || 0).toFixed(2) }} USD</div>
        </div>
        
        <div class="col-4">
          <span class="card-label-mini">Tasa BCV (Hoy)</span>
          <div class="fw-bold fs-5 mt-1">{{ parseFloat(bcvRate || 0).toFixed(2) }} Bs./USD</div>
        </div>
      </div>
      
  
      
      <!-- Divisor e Información de Datos Bancarios (solo si hay banco seleccionado) -->
      <BankDetailsInfo
        v-if="bankDetails"
        :bank-details="bankDetails"
        :payment-method="paymentMethod"
        theme="dark"
        class="d-none d-lg-block"
      />
      
      <!-- Mensaje informativo compacto si no hay banco seleccionado -->
      <template v-else>
        <hr class="card-divider my-3 d-none d-lg-block" />
        <div class="d-none d-lg-flex align-items-center justify-content-center text-center p-1 text-white-50 fs-7">
          <i class="fas fa-info-circle me-2 text-warning-light"></i>
          <span>Selecciona un Banco de Destino en el resumen para ver los datos de transferencia.</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import BankDetailsInfo from './BankDetailsInfo.vue';

defineProps({
  courseName: {
    type: String,
    default: ''
  },
  bcvRate: {
    type: [Number, String],
    default: 0
  },
  totalPaid: {
    type: [Number, String],
    default: 0
  },
  totalPending: {
    type: [Number, String],
    default: 0
  },
  bankDetails: {
    type: Object,
    default: null
  },
  paymentMethod: {
    type: String,
    default: 'pago_movil'
  }
});
</script>

<style scoped>
.section-title {
  color: #5a122d;
  font-size: 1.1rem;
}

.course-dark-card {
  background-color: #5a122d;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(90, 18, 45, 0.15);
  position: relative;
  overflow: hidden;
}

.course-dark-card::after {
  content: '';
  position: absolute;
  top: -30%;
  right: -10%;
  width: 150px;
  height: 150px;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 50%;
  pointer-events: none;
}

.card-label-mini {
  font-size: 0.72rem;
  color: rgba(255, 255, 255, 0.75);
  text-transform: uppercase;
  display: block;
  font-weight: 500;
  letter-spacing: 0.3px;
}

.fs-6-compact {
  font-size: 0.92rem;
  line-height: 1.2;
}

.rif-badge {
  background-color: rgba(255, 255, 255, 0.15);
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: normal;
}

.account-number-dark {
  font-family: monospace;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  background-color: rgba(0, 0, 0, 0.15);
  padding: 6px 10px;
  border-radius: 6px;
  display: inline-block;
  margin-top: 4px;
  border: 1px dashed rgba(255, 255, 255, 0.25);
}

.card-divider {
  border: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.18);
  opacity: 1;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.6) !important;
}

.text-warning-light {
  color: #ffda79;
}

.fs-7 {
  font-size: 0.8rem;
}
</style>
